export default {
  orders: 'forOrders',
  inventory: 'forInventory',
  jobs: 'forJobs',
  assets: 'forAssets',
}
